import React, { Fragment } from 'react'
import Title from '../../../../../components/typography/title.component'
import Button from '../../../../../components/buttons/buttons.component'
import FontAwesome from 'react-fontawesome'
import InnerPageContainer from '../../../../../components/layout/private/inner-page-container.component'
import { Link } from 'react-router-dom'
import { routes } from '../../../../../constants/routes.constants'
import { BACKGROUND } from '../../../../../styles/colors.style'
import { connect } from 'react-redux'
import { history } from './../../../../../helpers/history'
import { withRouter } from 'react-router-dom'
import { UserService } from '../../../../../services/user.service'
import { downloadFromURL } from '../../../../../helpers/download.helper'
import { bindActionCreators } from 'redux'
import { FALE_CONOSCO_EMAIL } from '../../../../../constants/fale-conosco.constants'
import { Creators as SiteCreators } from '../../../../../ducks/site/site'

const ExchangePoints = ({ isGift }) => (
	<Fragment>
		{isGift ? null : (
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					margin: '4rem auto',
				}}>
				<Button
					primary
					style={{ marginBottom: '4rem' }}
					onClick={() => history.push('/')}>
					Troque seus pontos por passagens
				</Button>
			</div>
		)}
		<p className="center">
			Em caso de dúvidas, envie um e-mail para{' '}
			<a href={`mailto:${FALE_CONOSCO_EMAIL}`} className="gray">
				{FALE_CONOSCO_EMAIL}
			</a>
		</p>
	</Fragment>
)

class ThanksPageComponent extends React.Component {
	EmailEnviado = (clientEmail) => (
		<p className="center">
			Um e-mail de confirmação do pedido de compra foi enviado para:{' '}
			{clientEmail}.
		</p>
	)

	render() {
		const {
			orderNumber,
			paymentMethod,
			name: client,
			email: clientEmail,
			isGift,
			bankSlipLink,
		} = this.props.location.state

		const isCreditCard = paymentMethod === 'creditCard'
		const isBankSlip = paymentMethod === 'bankSlip'
		const isOnlineDebt = paymentMethod === 'onlineDebt'
		const isDebitCard = paymentMethod === 'debitCard'

		return (
			<InnerPageContainer small>
				<Fragment>
					<Title>Obrigado {UserService.getFirstName(client)}!</Title>
					<FontAwesome
						name="star"
						size="5x"
						style={{
							color: `${BACKGROUND}`,
							display: 'block',
							textAlign: 'center',
						}}
					/>
				</Fragment>

				<h3 className="center">
					Pedido de compra <span className="bold blue">{orderNumber}</span>
				</h3>

				{(isCreditCard || isOnlineDebt || isDebitCard) && (
					<Fragment>
						{isGift ? (
							<h3 className="center">
								Os pontos de presente já estão disponíveis para uso!
							</h3>
						) : (
							<h3 className="center">
								Seus pontos já estão disponíveis para uso!
							</h3>
						)}
					</Fragment>
				)}

				{isBankSlip && <h3 className="center">Imprima seu boleto!</h3>}

				{isCreditCard && (
					<Fragment>
						<h3 className="center orange">
							Um e-mail de confirmação da compra foi enviado para{' '}
							{clientEmail}
						</h3>
						<p className="center">
							<Link
								to={`${routes.CLIENTE}/minhas-compras`}
								className="gray">
								Confira suas compras clicando aqui
							</Link>
						</p>
						<ExchangePoints isGift={isGift} />
					</Fragment>
				)}

				{isBankSlip && (
					<Fragment>
						<h3 className="orange center">
							Seus pontos serão creditados após o pagamento do boleto e
							compensação do mesmo pelo banco.
						</h3>
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
								margin: '4rem auto',
							}}>
							<Button
								primary
								onClick={() => {
									const { showLoading, hideLoading } = this.props
									showLoading()

									const downloadPromise = downloadFromURL(
										bankSlipLink,
										`boleto-moveflex-pedido-${orderNumber}.pdf`
									)

									downloadPromise
										.then(() => hideLoading())
										.catch(() => hideLoading())
								}}>
								Imprimir boleto
							</Button>
						</div>
						{this.EmailEnviado(clientEmail)}
						<p className="center">
							O prazo de confirmação dos pedidos pagos com boleto
							bancário começa a contar três dias depois do pagamento do
							boleto, tempo necessário para que a instituição bancária
							confirme o pagamento.
						</p>
						<p className="center">
							Caso o boleto não seja pago até o vencimento, o pedido será
							cancelado.
						</p>
						<p className="center">
							Em caso de dúvidas, envie um e-mail para{' '}
							<a href={`mailto:${FALE_CONOSCO_EMAIL}`} className="gray">
								{FALE_CONOSCO_EMAIL}
							</a>
						</p>
					</Fragment>
				)}

				{(isOnlineDebt || isDebitCard) && (
					<Fragment>
						<h3 className="orange center semi-bold">
							Seu pagamento foi recebido! Um e-mail de confirmação da
							compra foi enviado para {clientEmail}
						</h3>
						<p className="center">
							Confira suas compras clicando{' '}
							<Link to={`${routes.CLIENTE}/minhas-compras`}>aqui</Link>
						</p>
						<ExchangePoints isGift={isGift} />
					</Fragment>
				)}
			</InnerPageContainer>
		)
	}
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators({ ...SiteCreators }, dispatch)

const ThanksPage = withRouter(
	connect(null, mapDispatchToProps)(ThanksPageComponent)
)

export default ThanksPage
